import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../utils/api';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) return;

    const checkAuth = async () => {
      try {
        const response = await auth.getCurrentUser();
        setUser(response.data);
        setIsAuthenticated(true);
        // Store session_token in localStorage for API calls (Safari ITP fix)
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <img 
            src="/HoneyCookingCompanion_bee.svg" 
            alt="Loading" 
            className="w-16 h-16 mx-auto mb-4 animate-bounce"
          />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Store the intended URL before redirecting to login
    const intendedUrl = location.pathname + location.search;
    if (intendedUrl !== '/' && intendedUrl !== '/recipe-box') {
      sessionStorage.setItem('intendedUrl', intendedUrl);
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;